export default {
  completeProfile: {
    intro: {
      title: "Vamos configurar tudo",
      subtitle: "Algumas permissões rápidas ajudam a mostrar odds mais relevantes, enviar atualizações no momento certo e melhorar sua experiência.",
    },
    tracking: {
      title: "Ajude a manter o Linemate gratuito",
      subtitle: "Pedimos sua permissão para rastrear algumas atividades neste dispositivo. Ao selecionar “Permitir rastreamento” na próxima tela, você nos ajuda a:",
      buttonSubtext: "Você pode alterar essa opção depois no app Ajustes",
      cards: {
        support: {
          title: "Apoiar o Linemate",
          body: "Isso nos ajuda a continuar melhorando o app e os recursos que você mais usa.",
        },
        relevantContent: {
          title: "Ver conteúdo mais relevante",
          body: "Usamos esses dados para mostrar ofertas, tendências e anúncios mais relevantes para você.",
        },
      },
    },
  },
};